import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  NativeAppLogs_loading: false,
  NativeAppLogs_data: null,
  NativeAppLogs_error: null,
  NativeAppLogs_success: false,
};

const NativeAppLogsSlice = createSlice({
  name: "NativeAppLogs",
  initialState,
  reducers: {
    NativeAppLogsInit: (state) => {
      state.NativeAppLogs_loading = true;
      state.NativeAppLogs_error = null;
      state.NativeAppLogs_success = false;
    },
    NativeAppLogsSuccess: (state, action) => {
      state.NativeAppLogs_loading = false;
      state.NativeAppLogs_data = action.payload;
      state.NativeAppLogs_success = true;
    },
    NativeAppLogsFailure: (state, action) => {
      state.NativeAppLogs_loading = false;
      state.NativeAppLogs_error = action.payload;
      state.NativeAppLogs_success = false;
    },
    NativeAppLogsResetState: () => initialState,
  },
});

export const {
  NativeAppLogsInit,
  NativeAppLogsSuccess,
  NativeAppLogsFailure,
  NativeAppLogsResetState,
} = NativeAppLogsSlice.actions;

export default NativeAppLogsSlice.reducer;
